export const ROUTE_CONSTANT = {
  COMMON: {
    HOME: "/",
    NEWS: "/news",
    NEWSROOM_CONTROL: "/newsroom-control",
    NEWS_DETAILS: "/news-details/:newsId",
    TESTIMONIALS: "/testimonials",
    ADD_TESTIMONIAL: "/add_testimonial",
    FEEDBACKS: "/feedbacks",
    TRENDING_ARTIST: "/trending-artist",
    RECOMMENDED_ARTIST: "/recommended-artist",
    ADD_NEWS: "/add-news",
    SONG_LYRICS: "/lyrics/:isrcKey",
    ADD_HOT_SONGS: "/add-songs",
    ADD_HOT_ALBUM: "/add-hot-album",
    ALBUMS_SONGS: "/album/songs/:albumId",
    ARTIST_SONGS: "/artist/albums/:artistid",
    LIST_ARTISTS: '/artists',
    ADD_ARTIST: "/add-artist",
    EDIT_ARTIST: "/edit-artist/:id",
    RESET_PASSWORD: "/auth/reset-password/:token",
    SHOW_TESTIMONIAL: "/showtestimonial",
    TESTIMONIAL: "/testimonial",
    TOP_EXPLORE: "/top-explore",
    ADD_ALBUM: "/add-album",
    PLAYLIST: "/playlists",
    PLAYLIST_DETAILS: "/playlist/:playlistID",
    DASHBOARD: "/",
    RECOMMENDED_SONGS: "/recommended_songs",
    POPULAR_SONGS: "/popular_songs",
    CREATE_PLAYLIST: "/create_playlist",
    MOST_PLAYED_SONG: "/most-played-song",
    LIST_SONGS: "/all-songs",
    EDIT_SONG: "/edit-song/:id",
    ADD_SONG: "/add-song",
    QUIZ: "/quiz",
    ADD_QUIZ: "/add-quiz",
    EDIT_QUIZ: "/edit-quiz/:id",
    CONTACT_US: "/contact-us",
    ARTIST_ALBUMS_SONGS: "/artist/albums-songs/:artistId",
    TOP_ARTIST: "/top-artist",
    TOP_SONGS: "/top-songs",
    NEW_RELEASE_SONGS: "/new-release-songs",
    CONTRIBUTE_TO_LYRICS: "contribute-to-lyrics",
    SONG_LYRICS_CONTRIBUTIONS: "/song-lyrics-contributions",
    ALBUM_CONTRIBUTIONS: "/album-contributions",
    SONG_CONTRIBUTIONS: "/song-contributions",
    ARTIST_BIO_CONTRIBUTIONS: "/artist-bio-contributions",
    VIDEO_CONTRIBUTIONS: "/video-contributions",
    ARTIST_BIO: "/artist-bio",
    EDIT_ARTIST_BIO: "/edit-artist-bio",
    EDIT_NEWS: "/edit-news/:newsId",
    SUBSCRIBER: "/news-subscriber",
    YOUTUBE_VIDEOS: "/youtube-videos",
    BANNER_SECTION: "/banner-section",
    PODCAST_SECTION: '/podcast-section',
    PODCAST_ID: '/podcast/:id',
    USER_ACTIVITY: '/user-activity',
    ENGAGEMENT_ANALYTICS: '/analytics/engagement-report',
    CACHE_MANAGEMENT: '/cache-management',
    CONTENT_PREWARMING: '/content-prewarming',
    TAGS: '/tags',
    GENRES: '/genres',
    PAGE_MANAGEMENT: '/page-management',
    ADMIN_MANAGEMENT: '/admin-management',
    AUTHOR_MANAGEMENT: '/author-management',
    ADD_ADMIN: '/admin-management/add',
    EDIT_ADMIN: '/admin-management/edit/:id',
    SEND_NOTIFICATION: '/send-notification',
  },
  AUTH: {
    LOGIN: "/login",
    SHOW_PROFILE: "/profile",
    EDIT_PROFILE: "/edit-profile",
    CHANGE_PASSWORD: "/change-password",
    FORGET_PASSWORD: "/forget-password",
    RESET_PASSWORD: "/auth/reset-password/:resetToken",
    DEVELOPMENT: "/development",
    DEV_LOGIN: "/dev/login",
    DEV_FORGET: "/dev/forget",
    DEV_RESET: "/dev/reset",
    DEV_CHANGE: "/dev/change",
    DEV_SHOW: "/dev/show",
    DEV_EDIT: "/dev/edit",
  },
};
